export const initPushImages = (): void => {
    const banners = document.querySelectorAll<HTMLElement>('.app-crc-banner');

    if (banners.length === 0) return;

    banners.forEach(banner => {
        banner.addEventListener('click', (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const feature = target.closest<HTMLElement>('.app-crc-banner__feature');

            if (!feature) return;

            const header = feature.querySelector<HTMLButtonElement>('.app-crc-banner__feature-header');
            if (!header) return;

            e.preventDefault();

            const targetId = header.getAttribute('data-target');
            if (!targetId) return;

            banner.querySelectorAll<HTMLElement>('.app-crc-banner__feature-header')
                .forEach(h => h.classList.remove('is-active'));

            header.classList.add('is-active');

            banner.querySelectorAll<HTMLElement>('.app-crc-banner__image')
                .forEach(img => img.classList.toggle('is-active', img.getAttribute('data-id') === targetId));
        });
    });
};

// document.addEventListener('DOMContentLoaded', () => {
//     initPushImages();
// });